module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 164.04ca5573.png";